import {
  LOGIN_EMAIL,
  // ACTIVATE_TEXT,
  // UPDATE_TRANSCRIPT,
  // AUDIO_PLAYING,
  // AUDIO_SET_TIME,
  SET_SUBSCRIPTION_STATUS,
  SET_STREAM,
} from './Types'


export function loginWithEmail (params) {

  return {
    type: LOGIN_EMAIL,
    params
  }
}

// // ACTIVATE_TEXT
// export function activateTextCell (params) {
//
//   return {
//     type: ACTIVATE_TEXT,
//     params
//   }
// }

// // UPDATE_TRANSCRIPT
// export function updateTranscript (params) {
//
//   return {
//     type: UPDATE_TRANSCRIPT,
//     params
//   }
// }

// // AUDIO_PLAYING
// export function setAudioPlaying (params) {
//
//   return {
//     type: AUDIO_PLAYING,
//     params
//   }
// }

// // AUDIO_SET_TIME
// export function setAudioTime (params) {
//
//   return {
//     type: AUDIO_SET_TIME,
//     params
//   }
// }

// SET_SUBSCRIPTION_STATUS
export function setSubscriptionStatus (params) {

  return {
    type: SET_SUBSCRIPTION_STATUS,
    params
  }
}

// set stream
export function setStreams (params) {

  return {
    type: SET_STREAM,
    params
  }
}
